import styled from 'styled-components'
import { mediaqueries } from '../../../utils/mediaqueries'

import { Paragon, GreatPrimer, Brevier } from '~/components/Typography'

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;

  ${({ theme: { toRem, color } }) => `
      padding: ${toRem(25)} 0;
      border-bottom: 1px solid ${color('core')};
    `}

  &:last-of-type {
    border-bottom: 0;
  }

  @media ${mediaqueries.md} {
    margin-bottom: 0;
  }
`

export const ItemCol = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-start;
  flex: 0 0 calc(100% / 3);
  ${({ theme: { toRem } }) => `
    min-height: ${toRem(100)};
    padding: ${toRem(10)} 0;
  `}

  &:first-of-type {
    flex: 0 0 100%;
    justify-content: flex-start;
  }

  @media ${mediaqueries.md} {
    flex: 0 0 20%;
    justify-content: flex-end;

    &:first-of-type {
      flex: 0 0 40%;
    }

    ${({ theme: { toRem } }) => `
      padding: ${toRem(20)} 0;
    `}
  }
`

export const ItemImage = styled.div`
  height: 0;
  position: relative;
  width: 100%;
  cursor: pointer;

  #preview {
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.1);
  }

  ${({ theme: { color }, size }) => {
    const [width, height] = size.replace('cm', '').split('x')

    return `
      background: ${color('core')}
      padding-bottom: ${height / (width / 100)}%;
    `
  }}
`

export const ItemImageWrapper = styled.div`
  ${({ theme: { toRem } }) => `
      width: ${toRem(120)};
      margin-right: ${toRem(15)}
    `}

  @media ${mediaqueries.md} {
    ${({ theme: { toRem } }) => `
      margin-right: ${toRem(30)}
    `} 
  }
`

export const ItemContent = styled.div``

export const Title = styled(Paragon)`
  ${({ theme: { toRem } }) => `
      margin-bottom: ${toRem(20)};
    `}
`

export const Attribute = styled(GreatPrimer)`
  strong {
    font-weight: bold;
  }

  ${({ theme: { toRem } }) => `
      margin-bottom: ${toRem(5)};
      font-weight: 400 !important;
    `}
`

export const Button = styled(GreatPrimer)`
  position: relative;

  ${({ theme: { toRem, color } }) => `
    padding: 0 ${toRem(20)};
  
    button {
      font-size: 80%;
      position: absolute;
      left: 50%;
      transform: translateX(-50%) translateY(${toRem(0)});
      text-decoration: underline;
      appearance: none;
      border: none;
      cursor: pointer;
      color: ${color('core')}
    }
  `}
`

export const MobileLabel = styled(Brevier)`
  text-transform: uppercase;
  display: block;
  flex: 0 0 100%;
  font-weight: 100 !important;

  @media ${mediaqueries.md} {
    display: none;
  }
`
export const Striked = styled.span`
  text-decoration: line-through;
`